<template>
  <div class="group">
    <configField
      :id="id"
      :category="category"
      v-for="groupField in field.items"
      :key="getFieldData(groupField.id)['FieldId']"
      :field="getFieldData(groupField.id)"
      :value="getConfigValue(groupField.id)"
      hideLabel
      hideTooltip
      :parentField="parentField"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import configField from "@/components/config-field";

import getFieldData from "@/util/getFieldData";

export default {
  name: "Group",
  components: { configField },
  props: {
    category: {
      type: String,
    },
    field: {
      type: Object,
    },
    id: {
      type: String,
    },
    parentField: {
      type: String,
    },
  },
  computed: {
    fieldList() {
      const fieldData =
        this.configTemplate && this.configTemplate[this.category];
      return fieldData && fieldData.AvailableFieldList;
    },
    ...mapGetters({
      mergedConfig: "getMergedConfig",
      configTemplate: "getConfigTemplate",
    }),
  },
  methods: {
    getConfigValue(id) {
      let configValue =
        this.mergedConfig[this.id] && this.mergedConfig[this.id][this.category];
      if (this.parentField !== undefined) {
        configValue =
          configValue &&
          this.mergedConfig[this.id][this.category][this.parentField] &&
          this.mergedConfig[this.id][this.category][this.parentField][id];
      } else {
        configValue = configValue && this.mergedConfig[this.id][this.category][id];
      }
      return configValue;
    },
    getFieldData(id) {
      return getFieldData(this.fieldList, id);
    },
  },
};
</script>

<style lang="scss" scoped>
.group {
  & > div {
    margin-bottom: $qvo-spacing-16;
    &:last-child {
      margin-bottom: 0;
    }
  }

}
p.subtitle-2 {
  margin-bottom: $input-label-spacing;
}
</style>